/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { IObrienMainFaderData } from './obrien-main-fader.data';
import { IObrienMainFaderProps } from './obrien-main-fader.props.autogenerated';

export interface IObrienMainFaderViewProps extends IObrienMainFaderProps<IObrienMainFaderData> {

    slide1Image: React.ReactNode;
    slide2Image: React.ReactNode;
    slide3Image: React.ReactNode;
    slide4Image: React.ReactNode;
    slide5Image: React.ReactNode;
    obHeroImageOverlay: React.ReactNode;
    obHeroContent: string;
    obHeroButtonLink: string;
    obHeroButtonText: string;
    
}

/**
 *
 * ObrienProductSlider component
 * @extends {React.PureComponent<IObrienMainFaderProps<IObrienMainFaderData>>}
 */
class ObrienMainFader extends React.PureComponent<IObrienMainFaderProps<IObrienMainFaderData>> {
    public render(): JSX.Element | null {

        const { config } = this.props;

        const { 
            slide1Image,
            slide2Image,
            slide3Image,
            slide4Image,
            slide5Image,
            obHeroImageOverlay
        } = this.props.config;

        

        // Slide 1
        

        const imageOneProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: slide1Image && slide1Image.imageSettings,
        };

        const slideOneImage = slide1Image && (
            <Msdyn365.Image {...slide1Image} {...imageOneProps} editProps ={{key:this.props.config.slide1Image || {}, requestContext: this.props.context.request}}/>
        );

        // Slide 2
        

        const imageTwoProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: slide2Image && slide2Image.imageSettings,
        };

        const slideTwoImage = slide2Image && (
            <Msdyn365.Image {...slide2Image} {...imageTwoProps} editProps ={{key:this.props.config.slide2Image || {}, requestContext: this.props.context.request}}/>
        );

        // Slide 3
        

        const imageThreeProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: slide3Image && slide3Image.imageSettings,
        };

        const slideThreeImage = slide3Image && (
            <Msdyn365.Image {...slide3Image} {...imageThreeProps} editProps ={{key:this.props.config.slide3Image || {}, requestContext: this.props.context.request}}/>
        );

        // Slide 4
        
        const imageFourProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: slide4Image && slide4Image.imageSettings,
        };

        const slideFourImage = slide4Image && (
            <Msdyn365.Image {...slide4Image} {...imageFourProps} editProps ={{key:this.props.config.slide4Image || {}, requestContext: this.props.context.request}}/>
        );


        // Slide 5
        

        const imageFiveProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: slide5Image && slide5Image.imageSettings,
        };

        const slideFiveImage = slide5Image && (
            <Msdyn365.Image {...slide5Image} {...imageFiveProps} editProps ={{key:this.props.config.slide5Image || {}, requestContext: this.props.context.request}}/>
        );

        //
        const imageOverlayProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obHeroImageOverlay && obHeroImageOverlay.imageSettings,
        };

        const heroImageOverlay = obHeroImageOverlay && (
            <Msdyn365.Image {...obHeroImageOverlay} {...imageOverlayProps} editProps ={{key:this.props.config.obHeroImageOverlay || {}, requestContext: this.props.context.request}}/>
        );


        const HeroContent = config.obHeroContent ? config.obHeroContent : '';
        const HeroButtonLink = config.obHeroButtonLink ? config.obHeroButtonLink : 'No Link';
        const HeroButtonText = config.obHeroButtonText ? config.obHeroButtonText : 'No Text';
        const ObrienHomeFaderProps = {
            ...this.props,
            
            slide1Image: slideOneImage,
            
            slide2Image: slideTwoImage,
            
            slide3Image: slideThreeImage,
            
            slide4Image: slideFourImage,
            
            slide5Image: slideFiveImage,
            obHeroImageOverlay: heroImageOverlay,
            obHeroContent: HeroContent,
            obHeroButtonLink: HeroButtonLink,
            obHeroButtonText: HeroButtonText
            
        };


        return this.props.renderView(ObrienHomeFaderProps);
    }
}

export default ObrienMainFader;
